import { render, staticRenderFns } from "./sclass.vue?vue&type=template&id=3a2b879f&scoped=true&"
import script from "./sclass.vue?vue&type=script&lang=js&"
export * from "./sclass.vue?vue&type=script&lang=js&"
import style0 from "./sclass.vue?vue&type=style&index=0&id=3a2b879f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b879f",
  null
  
)

export default component.exports